module.exports = __webpack_public_path__ + "static/media/image6.fb22bb5b.jpg";